import { apiRegistry } from '../../../common/infra/apiRegistry'
import { wordsMem } from '../mem/wordsMem'

apiRegistry.registerGetApi('getWordDetail', async (req) => {
  const word = wordsMem[req.word.toLowerCase()]
  return { word: word || null }
})
